<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">MapKind</span>
      </v-card-title>

      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <mapkind-dropdown v-model="model" :clearable="true"/>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>

      <div
          class="resize-handle"
          @mousedown.stop.prevent="startResize"
      ></div>
    </v-card>
  </v-dialog>
</template>

<script>
import { ViewRules } from "@/common/ViewRules";
import { MapKindLiteModel } from "@/modules/mutils/models/MapKindLiteModel";
import MapkindDropdown from "@/modules/mutils/views/map-save-action/mapkind-dropdown.vue";

export default {
  name: "mapkind-dialog",
  components: { MapkindDropdown },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: null,
    rules: ViewRules.READONLY,

    dialogWidth: 288,
    dialogHeight: 260,

    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 288,
    resizeStartHeight: 260,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new MapKindLiteModel();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model && !this.isModelEmpty(this.model)) {
        console.log("Model to return:", this.model);
        this.discard();
        this.resolve && this.resolve(this.model);
      } else {
        this.$alert("Please select a MapKind!");
      }
    },
    cancel() {
      this.discard();
      this.reject && this.reject();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
      this.$nextTick(() => {
        this.model = null;
      });
    },
    isModelEmpty(model) {
      if (!model) return true;
      if (typeof MapKindLiteModel.isNone === "function") {
        return MapKindLiteModel.isNone(model);
      }
      return !model.key || model.key === "";
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;

      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;

      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;

      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;

      const minWidth = 230;
      const minHeight = 170;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;

      this.resizing = false;

      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resizable-card__body {
  flex: 1;
  overflow: auto;
}

.resizable-card__actions {
  flex-shrink: 0;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>